module.exports = __webpack_public_path__ + "media/images/icon-svg/download-blue-fd53c239ebba15a6665cfe923038b9da.svg";